const FormLabel = ({title, required = false}) => {
  return (
    <p className="formTitle">
      {title}
      {required && <span>*</span>}
    </p>
  );
}

export default FormLabel;